import React, { useState, useEffect } from "react";
import { FiCheckCircle, FiAlertCircle, FiClock } from "react-icons/fi";
import { useAuth } from "../../contexts/AuthContext";
import { useData } from "../../contexts/DataContext";
import { format, isPast, differenceInDays } from "date-fns";

// Safe date converter (handles Firestore Timestamps)
const toDate = v => { if(!v) return new Date(); if(typeof v?.toDate==="function") return v.toDate(); return new Date(v); };





export default function ParentHomework() {
  const { userData } = useAuth();
  const { getHomework, getSubmissions } = useData();
  const [hw, setHw]   = useState([]);
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const childId = userData?.children?.[0] || null;

  // eslint-disable-next-line
  useEffect(() => {
    if (!childId) { setLoading(false); return; }
    Promise.all([getHomework({}), getSubmissions({ studentId: childId })]).then(([h, s]) => {
      setHw(h); setSubs(s); setLoading(false);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const subMap = new Map(subs.map(s => [s.homeworkId, s]));
  const pending   = hw.filter(h => !subMap.has(h.id) && !isPast(toDate(h.deadline)));
  const submitted = hw.filter(h => subMap.has(h.id));
  const overdue   = hw.filter(h => !subMap.has(h.id) && isPast(toDate(h.deadline)));

  return (
    <div className="fade-in">
      <div className="page-head">
        <div>
          <h1 className="page-title">📚 Child's Homework</h1>
          <p className="page-subtitle">Monitoring: <strong>{userData?.childName || "Aarav Poudel"}</strong></p>
        </div>
      </div>

      {/* Summary */}
      <div className="g g3" style={{ marginBottom: 20 }}>
        {[
          { label:"Pending",   count:pending.length,   color:"var(--amber-600)", bg:"var(--amber-50)",  icon:<FiClock size={20}/> },
          { label:"Submitted", count:submitted.length, color:"var(--green-600)", bg:"var(--green-50)",  icon:<FiCheckCircle size={20}/> },
          { label:"Overdue",   count:overdue.length,   color:"var(--red-600)",   bg:"var(--red-50)",    icon:<FiAlertCircle size={20}/> },
        ].map(s => (
          <div key={s.label} className="card" style={{ padding:"16px 18px", display:"flex", alignItems:"center", gap:14 }}>
            <div style={{ width:44,height:44,borderRadius:"var(--r8)",background:s.bg,color:s.color,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0 }}>{s.icon}</div>
            <div>
              <div style={{ fontSize:"1.6rem",fontWeight:800,color:s.color,fontFamily:"Poppins,sans-serif",lineHeight:1 }}>{s.count}</div>
              <div style={{ fontSize:".78rem",color:"var(--gray-500)",marginTop:3 }}>{s.label}</div>
            </div>
          </div>
        ))}
      </div>

      {loading ? <div className="loading-center"><div className="spinner"/></div> : (
        <div className="card">
          <div className="card-header"><h3 className="card-title">All Assignments</h3></div>
          <div className="table-wrap">
            <table className="data-table">
              <thead><tr><th>Assignment</th><th>Subject</th><th>Deadline</th><th>Status</th><th>Grade</th></tr></thead>
              <tbody>
                {hw.map(h => {
                  const sub  = subMap.get(h.id);
                  const over = isPast(toDate(h.deadline));
                  const days = differenceInDays(toDate(h.deadline), new Date());
                  let statusLabel, statusClass;
                  if (sub)           { statusLabel = sub.status==="graded"?"Graded":"Submitted"; statusClass="badge-green"; }
                  else if (over)     { statusLabel = "Overdue"; statusClass="badge-red"; }
                  else if (days===0) { statusLabel = "Due Today!"; statusClass="badge-red"; }
                  else               { statusLabel = `${days}d left`; statusClass="badge-amber"; }
                  return (
                    <tr key={h.id}>
                      <td style={{ fontWeight:600 }}>{h.title}</td>
                      <td><span className="badge badge-blue" style={{fontSize:".68rem"}}>{h.subject}</span></td>
                      <td style={{ fontSize:".82rem",color:over&&!sub?"var(--red-600)":"var(--gray-700)" }}>{format(toDate(h.deadline),"MMM d, yyyy")}</td>
                      <td><span className={`badge ${statusClass}`} style={{fontSize:".68rem"}}>{statusLabel}</span></td>
                      <td style={{ fontWeight:700,color:"var(--green-600)" }}>{sub?.grade||"—"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
